import { cn } from "@/common/utils/cn";
import { renderIcon } from "@/common/utils/renderIcon";
import { LucideIcon } from "lucide-react";
import { HTMLProps } from "react";

interface SmallBadgeProps extends HTMLProps<HTMLDivElement> {
  LeftIcon?: LucideIcon | JSX.Element;
  RightIcon?: LucideIcon | JSX.Element;
  text?: string;
  className?: string;
  textClassName?: string;
}

const SmallBadge = ({
  LeftIcon,
  RightIcon,
  text,
  className,
  textClassName,
  children,
  ...props
}: SmallBadgeProps) => {
  return (
    <div
      className={cn(
        'p-1 flex items-center gap-1 bg-white-100 rounded-sm text-xs leading-none font-bold min-h-6',
        className
      )}
      {...props}
    >
      {renderIcon(LeftIcon)}

      {children || (!!text && (
        <span className={textClassName}>
          {text}
        </span>
      ))}

      {renderIcon(RightIcon)}
    </div>
  );
}

export default SmallBadge;
